(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pk-ugc-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pk-ugc-gallery')) {
    class PkUgcGallery extends HTMLElement {
      connectedCallback() {
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.hasAttribute('data-autoplay') && !this.reducedMotion;
        this.videos = Array.from(this.querySelectorAll('.pk-ugc__video'));
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);

        for (const video of this.videos) {
          video.addEventListener('play', () => this.sync(video));
          video.addEventListener('pause', () => this.sync(video));
          this.sync(video);
        }

        if (!this.autoplay || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              const video = entry.target;
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                if (video.dataset.userPaused !== 'true') this.play(video);
              } else if (!video.paused) {
                video.pause();
              }
            }
          },
          { threshold: [0, 0.5] }
        );
        for (const video of this.videos) this.observer.observe(video);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.observer) this.observer.disconnect();
      }

      play(video) {
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
      }

      onClick(event) {
        const button = event.target.closest('.pk-ugc__toggle');
        if (!button) return;
        const video = button.parentElement.querySelector('.pk-ugc__video');
        if (!video) return;
        if (video.paused) {
          video.dataset.userPaused = 'false';
          this.play(video);
        } else {
          video.dataset.userPaused = 'true';
          video.pause();
        }
      }

      sync(video) {
        const button = video.parentElement.querySelector('.pk-ugc__toggle');
        if (!button) return;
        const playing = !video.paused;
        button.setAttribute('aria-pressed', playing ? 'true' : 'false');
        button.setAttribute('aria-label', playing ? button.dataset.labelPause : button.dataset.labelPlay);
      }
    }
    customElements.define('pk-ugc-gallery', PkUgcGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
